import { render } from "./DueAppointmentNotification.vue?vue&type=template&id=6bbb288b&scoped=true"
import script from "./DueAppointmentNotification.vue?vue&type=script&lang=js"
export * from "./DueAppointmentNotification.vue?vue&type=script&lang=js"

import "./DueAppointmentNotification.vue?vue&type=style&index=0&id=6bbb288b&scoped=true&lang=less"

import exportComponent from "C:\\Users\\sander\\IdeaProjects\\matchmaking\\fbm-matchmaking\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bbb288b"]])

export default __exports__